import React, {Component} from 'react';

//import Scss
import './assets/scss/themes.scss';

import './assets/scss/custom.scss';

//import Route
import Route from './Routes';

import {AuthAPI} from "api";
import {mandaAlPortale} from "./passaggioPortale";

import {Loading, Utils, CustomModal} from "custom";

import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import {checkVers} from "./CheckBuildService";

/* 🔴 L'INTERRUTTORE CAMBIATO CON LA SCHEDA APERTA (V4, revisione del 22/10/2026).
   Una scheda aperta da prima dell'accensione di ECONOMIA_SU_ATOM / SEGNALATORI_SU_ATOM mostra
   ancora Vendite, Pagamenti e Network: il primo 409 dell'API dice che i flag sono cambiati.
   Si rileggono (`/auth/permission` li riscrive in sessionStorage) e si ricarica UNA volta: il
   segno in sessionStorage evita un ciclo se il 409 arrivasse anche dopo il ricarico. */
const STATI_INTERRUTTORE = ["ECONOMY_ON_ATOM", "NETWORK_ON_ATOM"];
const SEGNO_RICARICO = "interruttoreRicaricato";

async function riallineaInterruttori() {
    let ultimo = 0;
    try { ultimo = Number(sessionStorage.getItem(SEGNO_RICARICO)) || 0; } catch (e) { /* senza storage niente ricarico */ return; }
    if (Date.now() - ultimo < 60000) return;
    try { sessionStorage.setItem(SEGNO_RICARICO, String(Date.now())); } catch (e) { return; }
    try { await AuthAPI.permission(); } catch (e) { /* il login lo gestisce il giro normale */ }
    window.location.reload();
}

global.checkAuth = async function (status) {
    if (STATI_INTERRUTTORE.includes(status)) {
        await riallineaInterruttori();
        return;
    }

    if (status === "NO_PERMISSION") {

        // window.location.replace('/unauthorized');
    }

    if (status === "UNAUTHORIZED") {
        try {
            await AuthAPI.logout();
        } catch(e) {
            localStorage.removeItem('hash');
            sessionStorage.removeItem("userData");
            global.userData = undefined;
            window.location.replace('/login');
        }
    }
};

global.SweetAlert = withReactContent(Swal);

class App extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true
        };
    }

    componentDidMount() {
        checkVers().then(() => {
            Utils.checkConnection().then(() => {
                // Le pagine embed (/embed/*) gestiscono la sessione da sole, con un gettone
                // nell'indirizzo: il giro permission/redirect-login qui sotto le manderebbe
                // al login del gestionale DENTRO l'iframe di ATOM. Si saltano, come /redirect.
                if (["/redirect", "/session/error"].includes(window.location.pathname)
                    || window.location.pathname.startsWith("/embed/")) {
                    this.setState({loading: false});
                    return;
                }

                AuthAPI.permission().then((userData) => {
                    // CHI E' GIA' DENTRO. E' il caso piu' frequente: il corsista apre un vecchio
                    // segnalibro e la sessione e' ancora valida. Chi non e' ADMIN o CONSULENT
                    // prosegue sul portale nuovo, e il gestionale non si disegna MAI per lui:
                    // se il passaggio non parte, esce comunque (vedi passaggioPortale.js).
                    mandaAlPortale(userData).then((inCorso) => {
                        if (!inCorso) this.setState({loading: false});
                        // se sta partendo si lascia la schermata di attesa: la pagina sta cambiando
                    });
                }).catch(() => {
                    this.setState({loading: false});
                    if (window.location.pathname !== '/login')
                        window.location.replace('/login');
                });
            }).catch(() => {
                this.setState({loading: false});
                if (window.location.pathname !== '/offline')
                    window.location.replace('/offline');
            })
        }).catch((err) => {
            console.error(err)
        })
    }

    render() {
        return (
            <React.Fragment>
                {(this.state.loading) ? <Loading/> : <Route/>}
                <CustomModal/>
            </React.Fragment>
        );
    }
}

export default App;
